
import HomeBase from "./components/Base";
import Tabbar from "@/components/fragments/Tabbar";

export default function HomeFeature() {
  return (
    <div className="relative">
      <HomeBase />
      <Tabbar />
    </div>
  );
}
